import React, { useCallback, useEffect, useState } from 'react';
import { ListItem } from './ListItem';
import update from 'immutability-helper';
import usePrevious from '../../hooks/usePrevious';


function SimpleDNDList({ items, Card, onChange }) {
	const moveCard = useCallback((dragIndex, hoverIndex) => {
		onChange((prevCards) =>
			update(prevCards, {
				$splice: [
					[dragIndex, 1],
					[hoverIndex, 0, prevCards[dragIndex]],
				],
			})
		);
	}, []);

	const renderCard = useCallback((card, index) => {
		return (
			<ListItem key={card.id} index={index} id={card.id} moveCard={moveCard}>
				<Card item={card} />
			</ListItem>
		);
	}, []);

	return (
		<div className="SimpleDNDList">
			<div>{items?.map((card, i) => renderCard(card, i))}</div>
		</div>
	);
}

export default SimpleDNDList;
